const DEFAULT_OFFSET = 24;

export const scrollToAnchor = (hash: string, behavior: ScrollBehavior = "smooth") => {
  const targetId = hash.replace(/^#/, "");
  if (!targetId) return false;

  const target = document.getElementById(targetId);
  if (!target) return false;

  const nav = document.querySelector("nav");
  const navHeight = nav?.getBoundingClientRect().height ?? 0;
  const top = target.getBoundingClientRect().top + window.scrollY - navHeight - DEFAULT_OFFSET;

  window.scrollTo({
    top: Math.max(0, Math.round(top)),
    behavior,
  });

  return true;
};

export const waitAndScrollToAnchor = (hash: string, behavior: ScrollBehavior = "smooth") => {
  let attempts = 0;
  const maxAttempts = 60;

  const tryScroll = () => {
    if (scrollToAnchor(hash, behavior)) return;
    if (attempts++ < maxAttempts) {
      window.setTimeout(tryScroll, 50);
    }
  };

  tryScroll();
};